import { Flex } from 'antd'
import { Modal, Button, Icon } from 'mysaiva-web-components'
import { useTranslation } from 'react-i18next'
import styles from './ExpirationPasswordModal.module.scss'

type ExpirationPasswordPopupProps = {
  open: boolean
  isLessThanOneDay?: boolean
  daysUntilExpiration?: number
  onCancel: () => void
  onOk: () => void
}

export function ExpirationPasswordModal(props: ExpirationPasswordPopupProps) {
  const {
    open,
    isLessThanOneDay,
    daysUntilExpiration = 1,
    onCancel,
    onOk
  } = props

  const { t } = useTranslation()

  // Function to determine the expiration message
  const getExpirationMessage = () => {
    if (isLessThanOneDay || daysUntilExpiration == 0)
      return t('expirationPasswordModal.expiresToday')
    return t('expirationPasswordModal.expiresInDays', {
      days: daysUntilExpiration
    })
  }

  const footer = (
    <Flex gap={16} justify="end">
      {/* Hide the cancel button if less than one day */}
      {!isLessThanOneDay && (
        <Button onClick={onCancel}>
          {t('expirationPasswordModal.cancel')}
        </Button>
      )}
      <Button type="primary" onClick={onOk}>
        {t('expirationPasswordModal.confirm')}
      </Button>
    </Flex>
  )

  const title = (
    <Flex gap={12} align="center">
      <div className={styles.icon}>
        <Icon icon="WarningCircle" style={{ color: 'red', fontSize: '24px' }} />
      </div>
      <h4>{t('expirationPasswordModal.title')}</h4>
    </Flex>
  )

  return (
    <Modal open={open} footer={footer} title={title} closable={false}>
      {getExpirationMessage()}
    </Modal>
  )
}
